import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { PdfReaderView } from 'src/components/material/reader-poc/pdfLectorAdapter';
import { FixtureReaderPage } from 'src/components/material/reader-poc/FixtureReaderPage';
import pdfFixtureUrl from 'src/components/material/reader-poc/fixtures/LAD_Portal_Product_Update_Mar-Jul_2026.pdf?url';

import type { ReaderDocument } from 'src/components/material/reader-poc/types';

/**
 * PDF showcase: the shell driving the Lector adapter against a bundled
 * fixture. The EPUB route's twin, so the same shell behaviour can be exercised
 * on both renderers without a course, a material or a token.
 *
 * Unauthenticated on purpose — see `FixtureReaderPage` for why.
 */
const PdfReaderPocPage = () => {
  const pdfDocument = useMemo<ReaderDocument>(
    () => ({
      id: 'fixture-pdf-product-update',
      kind: 'pdf',
      title: 'LAD Portal Product Update',
      source: {
        kind: 'url',
        url: pdfFixtureUrl,
      },
    }),
    []
  );

  return <FixtureReaderPage document={pdfDocument} View={PdfReaderView} />;
};

export const Route = createFileRoute('/reader-poc/pdf')({
  component: PdfReaderPocPage,
});
